module.exports = __webpack_public_path__ + "static/media/task.f93c31c5.svg";